module.exports = __webpack_public_path__ + "img/arrow_left.f8d8f793.svg";